import React from "react";
import Companies from "./Companies";

function Mycompany() {
  const dragable = false;
  return <Companies myCompanyRoute="true" dragable={dragable} />;
}

export default Mycompany;
